export class Auth {
  constructor(http) {
    this.http = http;
  }

  authenticate(login, password) {
    return this.http.post('login/', { login, password });
  }

  logout() {
    return this.http.post('logout/');
  }
}
